import { createSelector } from 'reselect'

const getWhiteboardData = state => state.whiteboardSession

const drawingIdSelector = createSelector(
	[ getWhiteboardData ],
	whiteboard => whiteboard.currentDrawingId
)

export default drawingIdSelector
